import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {StarRating} from '@vio/atlas/StarRating'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook -- experiment-scoped star colour, see sc-195428
import {getIsBrandVio} from '@vio/core/src/_web/brand/modules/selectors'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {HotelDetailsLoading} from './HotelDetailsLoading'

// Using an inline spacer to avoid issues with margin and a long title that wraps to the next line
const StarsSpacer = styled.span`
  display: inline-block;
  width: ${cssTheme.layout.spacing.s200};
`

const HotelDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
`

const APFoldHotelDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${cssTheme.layout.spacing.s250};
`

const StarsWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s300};
`

interface PropsTypes {
  hotel?: ContentHotel
}
export const HotelDetails: React.FC<PropsTypes> = ({hotel}) => {
  const {isMobile} = useDeviceLayout()
  const toggle = useToggle()
  const isBrandVio = useSelector(getIsBrandVio)

  // Show HotelDetails loading
  if (!hotel) return <HotelDetailsLoading />

  if (isMobile) {
    return (
      <>
        {toggle(
          '90ef358d-ap-first-fold-improvement-v2',
          <HotelDetailsWrapper>
            <Text variant="titleL" tag="h1">
              <span data-id="HotelName">{hotel.hotelName}</span>
              <StarsSpacer />
              <StarRating
                size="xs"
                data-id="StarRating"
                rating={hotel.starRating}
                isInline
              />
            </Text>
          </HotelDetailsWrapper>,
          <APFoldHotelDetailsWrapper>
            <StarRating
              size="sm"
              colorPath={
                isBrandVio ? 'content.accent.secondary' : 'starRating.content'
              }
              data-id="StarRating"
              rating={hotel.starRating}
              isInline
            />
            <Text variant="titleXL" tag="h1">
              <span data-id="HotelName">{hotel.hotelName}</span>
            </Text>
          </APFoldHotelDetailsWrapper>
        )}
      </>
    )
  }

  return (
    <>
      <StarsWrapper>
        <StarRating
          size="xs"
          data-id="StarRating"
          rating={hotel.starRating}
          isInline
        />
      </StarsWrapper>
      <Text variant="titleXL" dataId="HotelName" tag="h1">
        {hotel.hotelName}
        <StarsSpacer />
      </Text>
    </>
  )
}
